/**
 * Design System - FeedbackButton Component
 * Like/Dislike feedback button
 */

import React from 'react';
import {
  typographyColors,
  backgroundColors,
  borders,
  dimensions,
} from '../../utils';

export interface FeedbackButtonProps {
  type: 'like' | 'dislike';
  isActive?: boolean;
  onClick?: () => void;
  ariaLabel?: string;
}

export const FeedbackButton: React.FC<FeedbackButtonProps> = ({
  type,
  isActive = false,
  onClick,
  ariaLabel,
}) => {
  const getIcon = () => {
    if (type === 'like') {
      return (
        <svg
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10 15V5M10 5L5 10M10 5L15 10'
            stroke={
              isActive ? typographyColors.primary : typographyColors.tertiary
            }
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            transform='rotate(180 10 10)'
          />
        </svg>
      );
    } else {
      return (
        <svg
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10 5V15M10 15L5 10M10 15L15 10'
            stroke={
              isActive ? typographyColors.primary : typographyColors.tertiary
            }
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    }
  };

  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel || `${type} button`}
      style={{
        width: dimensions.component.feedbackButton.width,
        height: dimensions.component.feedbackButton.height,
        backgroundColor: isActive
          ? backgroundColors.shade
          : backgroundColors.primary,
        borderColor: backgroundColors.shade,
        borderWidth: borders.width.thin,
        borderStyle: 'solid',
        borderRadius: borders.radius.sm,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s',
      }}
      onMouseEnter={e => {
        if (onClick && !isActive) {
          e.currentTarget.style.backgroundColor = backgroundColors.secondary;
        }
      }}
      onMouseLeave={e => {
        if (onClick && !isActive) {
          e.currentTarget.style.backgroundColor = backgroundColors.primary;
        }
      }}
    >
      {getIcon()}
    </button>
  );
};
